import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { VALIDATION_STATES } from '../../utils/constants';
import { apple, boulder, thunderBird } from '@parchment/atoms';
import { ValidIcon, WarningIcon, SecureIcon, ValidationRequiredIcon } from '@parchment/icons';
export default class ValidationIcon extends React.Component {
  static get propTypes() {
    return {
      value: PropTypes.object || PropTypes.string,
      valid: PropTypes.oneOf(Object.values(VALIDATION_STATES)),
      visited: PropTypes.bool,
      disabled: PropTypes.bool,
      required: PropTypes.bool
    };
  }
  render() {
    const {
      valid,
      visited,
      value,
      disabled,
      required
    } = this.props;
    if (!disabled) {
      if (visited) {
        switch (valid) {
          case VALIDATION_STATES.success:
            return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SuccessIcon, {
              color: apple,
              role: "img",
              ariaHidden: false,
              "aria-label": "success",
              alt: "success",
              noPad: true
            }), value);
          case VALIDATION_STATES.error:
            return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ErrorIcon, {
              color: thunderBird,
              role: "img",
              ariaHidden: false,
              "aria-label": "error",
              alt: "error",
              noPad: true
            }), value);
          default:
            return value || null;
        }
      } else {
        if (required) {
          return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(RequiredIcon, {
            color: thunderBird,
            role: "img",
            ariaHidden: false,
            "aria-label": "required",
            alt: "required",
            noPad: true
          }), value);
        }
        return value || null;
      }
    } else {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(LockIcon, {
        color: boulder,
        role: "img",
        ariaHidden: false,
        "aria-label": "locked",
        alt: "locked",
        noPad: true
      }), value);
    }
  }
}
const SuccessIcon = /*#__PURE__*/styled(ValidIcon).withConfig({
  displayName: "ValidationIcon__SuccessIcon",
  componentId: "sc-1n5um8b-0"
})(["margin-right:10px;margin-left:2px;"]);
const ErrorIcon = /*#__PURE__*/styled(WarningIcon).withConfig({
  displayName: "ValidationIcon__ErrorIcon",
  componentId: "sc-1n5um8b-1"
})(["margin-right:10px;margin-left:2px;"]);
const LockIcon = /*#__PURE__*/styled(SecureIcon).withConfig({
  displayName: "ValidationIcon__LockIcon",
  componentId: "sc-1n5um8b-2"
})(["margin-right:10px;margin-left:4px;"]);
const RequiredIcon = /*#__PURE__*/styled(ValidationRequiredIcon).withConfig({
  displayName: "ValidationIcon__RequiredIcon",
  componentId: "sc-1n5um8b-3"
})(["margin-right:10px;margin-left:4px;"]);